//过滤器，自定义组件，全局方法，实例方法，mixin等在这里添加
export default {
    install (Vue, options) {
        //自定义指令
        // Vue.directive('my-directive', {
        // 	bind (el, binding, vnode, oldVnode) {
        // 	  // 逻辑...
        // 	}
        // })
        // 注入组件选项
        Vue.mixin({
            methods: {
                // getSms () {
                //     return new Promise((resolve, reject) => {
                //         this.$http.post(API_URL_BASE_API + '/sms/get_sms/', {
                //             "sms_id": 3
                //         }).then(res => {
                //             this.smsContent = res.data.data.content;
                //             this.smsId = res.data.data.id;
                //             resolve(res);
                //         })
                //     })
                // },
                // replaceSms (sms) {
                //     if (!this.smsContent.length) {
                //         return false;
                //     }
                //     let content = this.smsContent.replace('{now_time}', this.smsParams.now_time).replace('{end_time}', this.smsParams.end_time).replace('{subject}', this.smsParams.subject).replace('{task_type}', this.smsParams.task_type).replace('{user_name}', this.smsParams.user_name).trim(); //不可以用全部空格
                //     return content;
                // },
                // appFunction (name, obj, url) {
                //     let array = [];
                //     obj = obj ? obj : "";
                //     if (obj.indexOf(',') > -1) {
                //         array = obj.split(',')
                //     } else {
                //         array.push(obj)
                //     }
                //     if (name == "ys_task_list_eng") {//特殊方法，传递参数不同
                //         let _o = {
                //             id: array[0],
                //             key1: array[1],
                //             key2: array[2]
                //         }
                //         array = _o;
                //     }
                //     let platform = localStorage.getItem("search") && JSON.parse(localStorage.getItem("search")).platform;
                //     if (platform == '3') {
                //         try {
                //             window.webkit.messageHandlers[`${name}`].postMessage(array);
                //         } catch (e) {
                //             if (url == '1') {
                //                 this.$router.go(-1)
                //             } else if (url && url.length > 0) {
                //                 this.$router.push(url)
                //             }
                //             console.log(e)
                //         }
                //     } else {
                //         let appObg = obj ? `${name},${obj}` : `${name}`;
                //         try {
                //             appobject.Interactive(appObg)
                //         } catch (e) {
                //             if (url == '1') {
                //                 this.$router.go(-1)
                //             } else if (url && url.length > 0) {
                //                 this.$router.push(url)
                //             }
                //             console.log(e)
                //         }
                //     }
                // },
            }
        })

        //自定义过滤器
        Vue.filter('formatTime', function (value) {
            //13位时间戳
            Date.prototype.Format = function (fmt) { //author: meizz
                var o = {
                    "M+": this.getMonth() + 1, //月份
                    "d+": this.getDate(), //日
                    "h+": this.getHours(), //小时
                    "m+": this.getMinutes(), //分
                    "s+": this.getSeconds(), //秒
                    "q+": Math.floor((this.getMonth() + 3) / 3), //季度
                    "S": this.getMilliseconds() //毫秒
                };
                if (/(y+)/.test(fmt))
                    fmt = fmt.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
                for (var k in o)
                    if (new RegExp("(" + k + ")").test(fmt))
                        fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
                return fmt;
            }
            return new Date(value).Format("yyyy-MM-dd hh:mm:ss");
        })
        // 请求拦截器
        options.axios.interceptors.request.use(request => {
            let tbkt_token = localStorage.getItem("Tbkt-Token") || ''
            if (tbkt_token) request.headers['Tbkt-Token'] = tbkt_token
            request.headers['App-Type'] = 14
            request.timeout = 120000;
            return request
        });
        // 返回拦截器
        options.axios.interceptors.response.use(response => {
            let _data = response.data;
            if (_data.error == 'no_user' && _data.response == 'fail') {
                let platform = localStorage.getItem("search") && JSON.parse(localStorage.getItem("search")).platform;
                if (platform == 3) {//ios通知原生跳转登录
                    try { window.webkit.messageHandlers.ys_nouser.postMessage([""]) } catch (e) { }
                } else if (platform == 1) {//android通知原生跳转登录
                    try { appobject.Interactive('ys_nouser') } catch (e) { }
                } else {
                    let current_url = location.href;
                    if(current_url.indexOf("/login") == -1 && current_url.indexOf("/devlogin") == -1){
                        options.router.push('/login');
                        let title = localStorage.getItem("Tbkt-Token") ? "您的登录已过期，请重新登录" : "您还未登录，请先登录";
                        layer.alert(title, {}, function (index) {
                            layer.close(index);
                        })
                    }
                }
            }
            return response
        }, error => {
            return Promise.reject(error);
        });
        Vue.prototype.$http = options.axios;
    }
}